module.exports = __webpack_public_path__ + "0f80e21e5c65e44f2da6ab861e9d31d7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/earbuds-blue.png
// module id = 1800
// module chunks = 0